<template>
  <div class="admin-layout">
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
      <side-bar
          :background-color="sidebarBackground"
          short-title="Cari"
          title="Cari">
        <template slot="links">
          <template v-for="(menuItem, key) in menu" v-if="menuItem.showing">
            <sidebar-dropdown v-if="menuItem.children && menuItem.children.length > 0" :color="menuItem.color" :key="key"
                              :name="menuItem.label" :icon="menuItem.icon" >
              <sidebar-item v-for="(subItem, subKey) in menuItem.children" :key="subKey" :label="subItem.label"
                            :icon="subItem.icon" :to="{...subItem.to,params:subItem.params}"/>
            </sidebar-dropdown>
            <sidebar-item v-else :color="menuItem.color" :key="key" :label="menuItem.label" :icon="menuItem.icon"
                          :to="{...menuItem.to,params:menuItem.params}"/>
          </template>
  
  <!--        <li class="nav-item">-->
  <!--          <a href="#" @click.prevent="logoutAction" class="nav-link">-->
  <!--            <i class="ni ni-user-run text-default"></i>-->
  <!--            <span class="nav-link-text">Çıkış Yap</span>-->
  <!--          </a>-->
  <!--        </li>-->
  
        </template>
      </side-bar>
      <div class="main-content" :data="sidebarBackground">
        <dashboard-navbar></dashboard-navbar>
  
        <div @click="toggleSidebar">
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <router-view></router-view>
          </fade-transition>
          <!--        <content-footer v-if="!$route.meta.hideFooter"></content-footer>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import DashboardNavbar from './DashboardNavbar.vue';
import {FadeTransition} from 'vue2-transitions';

import menu from '../config/menu';
import SidebarDropdown from '../components/SidebarDropdown'
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    SidebarDropdown,
    DashboardNavbar,
    FadeTransition,
  },
  data() {
    return {
      menu,
      sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
    };
  },
  computed: {
    ...mapGetters(['user']),
    accountExpired() {
      
    },
  },
  methods: {
    ...mapActions(['getUser', 'logout']),
    logoutAction() {
      this.logout().then(() => {
        this.$router.go({name: 'login'});
      })
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

  },
  async mounted() {
    await this.getUser()
    this.menu.forEach(item => {
      if (item.label == 'Kasa' && !this.user.homepage_permission)
        item.showing = false;
      if (item.label == 'Ürünler' && !this.user.homepage_permission)
        item.showing = false;
      if (item.label == 'Gelir Gider' && !this.user.homepage_permission)
        item.showing = false;
      if (item.label == 'Raporlar' && !this.user.homepage_permission)
        item.showing = false;
      if (item.label == 'Anasayfa' && !this.user.homepage_permission)
        item.showing = false;

      

    })
  }
};
</script>
<style>
.admin-layout {
  background-color: #6d6d6d !important;
}
</style>
